import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export function getPermanentSuspensionDate() {
  return new Date('2038-01-01');
}
export function isPermanentSuspensionDate(date) {
  return dayjs.utc(date).isSame(dayjs.utc('2038-01-01'));
}
export function localStorageKey() {
  return 'flarum-suspend.acknowledge-suspension';
}
flarum.reg.add('flarum-suspend', 'forum/helpers/suspensionHelper', { getPermanentSuspensionDate: getPermanentSuspensionDate,isPermanentSuspensionDate: isPermanentSuspensionDate,localStorageKey: localStorageKey, });